

export function useCdnUrl(target: string): string {
    const config = useRuntimeConfig();

    return config.cdnUrl + target;
}